/**
* @ngdoc component
* @name common.component:itxStoreType
* @description
* A component to show a selector of store types 
* @param {object} model model object
* @param {object} form ng form object
*/
(function() {
  'use strict';

  var itxStoreType = {
    bindings: {
      model:'=',
      form:'=',
      onSelectStoreType:'&'
    },
    controller:   itxStoreTypeCtrl,
    templateUrl: 'store-type.component.html'
  };

  itxStoreTypeCtrl.$inject = [
    '$timeout',
    'ItxTranslateSvc',
    'CountryService',
    'DUTTI_CONS'
  ];

  function itxStoreTypeCtrl (
    $timeout,
    ItxTranslateSvc,
    CountryService,
    DUTTI_CONS
  ) {
    var _this = this;

    _this.$onInit = function () {
      
      _this.storeTypeOpened = false;

      // Crea el objeto de las distintas opciones de contacto
      _this.storeTypes = [];

      // Añade la opción de tienda física en caso de no ser USA
      if(!CountryService.is(DUTTI_CONS.country.US)) {
        _this.storeTypes.push({id:2, type: ItxTranslateSvc.translateCms('legacy.ItxContactView.option.store.title')});
      }
      
      if(inditex.iStoreJSON.isOpenForSale && inditex.iStoreJSON.type === 1) {
        _this.storeTypes.push({id:1, type: ItxTranslateSvc.translateCms('legacy.ItxContactView.option.online.title')});
      }

      _this.model.storeType = _this.storeTypes[0].type;
    };

    _this.onStoreTypeSelected = function (store) {
      _this.onSelectStoreType({store: store});
    };

    _this.onStoreTypeEvent = function (opened) {
      $timeout(function () {
          _this.storeTypeOpened = opened;
      });
    };

  }

  angular.module('itxApp.common')
  .component('itxStoreType',itxStoreType);

})();